export const toMoney = (
  num,
  options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }
) => {
  return new Intl.NumberFormat("en-US", options).format(num);
};
export const toMoneyDecimal = (
  num,
  options = {
    minimumFractionDigits: 2,
    // maximumFractionDigits: 0,
  }
) => {
  return new Intl.NumberFormat("en-US", options).format(num);
};

export const formatNumberOnInput = (
  rawValue,
  { allowDecimals = false, maxDecimals = 2 } = {}
) => {
  let value = String(rawValue).replace(/,/g, "");

  if (allowDecimals) {
    value = value.replace(/[^\d.]/g, "");
    const dotIndex = value.indexOf(".");
    if (dotIndex !== -1) {
      value =
        value.slice(0, dotIndex + 1) +
        value.slice(dotIndex + 1).replace(/\./g, "");
      if (value.slice(dotIndex + 1).length > maxDecimals) {
        value = value.slice(0, dotIndex + maxDecimals + 1);
      }
    }
  } else {
    value = value.replace(/\D/g, "");
  }

  if (value === "" || value === ".") return value;

  const [integerPart, decimalPart] = value.split(".");
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (decimalPart !== undefined) {
    return `${formattedInteger}.${decimalPart}`;
  }

  return formattedInteger;
};

export const parseNumberInput = (formattedValue) => {
  if (!formattedValue && formattedValue !== 0) return 0;
  const cleaned = String(formattedValue).replace(/,/g, "");
  if (cleaned === "" || cleaned === ".") return 0;
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

export const downloadCsvFile = (csv = "", filename, setDownloadData, toast) => {
  if (csv && csv.length > 0) {
    // export successfull
    setDownloadData(csv);
    let hiddenElement = document.createElement("a");
    let blob = new Blob(["\ufeff", csv]);
    let url = URL.createObjectURL(blob);
    hiddenElement.href = url;
    // hiddenElement.target = "_blank";
    hiddenElement.download = filename;
    hiddenElement.click();
    hiddenElement.remove(); // experimental, hopefully prevent creating too many nodes
    toast.success("Download Succesful");
  } else {
    toast.error("download failed");
  }
};
